module.exports = __webpack_public_path__ + "static/media/welcome-modal-practical-support.e3ca9144.jpg";